import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const toastMessage = (type, message) => {
    toast.dismiss();
    toast[type](message);
};